<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <form-toolbar title="Guía de uso" :home-button="false" back-button-default="/" />
      </ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="true" class="ion-padding">

      <h2>Crear nueva incidencia</h2>

      <p>Desde la página de inicio pulse en botón <ion-text color="primary">ENTRAR</ion-text> o
        pulse el botón <ion-text color="primary">Nueva</ion-text> <ion-icon :icon="duplicateOutline" color="primary" /></p>

      <ul class="unordered-list steps">
        <li>
          <span class="step">Paso 1:</span> Seleccione una categoría a la que corresponda la incidencia.
        </li>
        <li>
          <span class="step">Paso 2:</span> Si lo desea puede tomar o seleccionar fotografías (máximo {{ maxFiles }}) con su dispositivo (opcional).
        </li>
        <li>
          <span class="step">Paso 3:</span> Geolocalice la incidencia. Por defecto la app automáticamente seleccionará donde se encuentre.
          Puede forzar la selección de su posición actual pulsando el botón <ion-icon :icon="locateOutline" color="primary"/>.
          También puede seleccionar la ubicación utilizando el buscador o desplazando el marcador
          <img :src="`${publicPath}img/marker-icon.png`" alt="Marker icon" class="marker-map-redux">.
          Una vez la dirección sea la deseada pulse en el botón <ion-text color="success">Continuar</ion-text>
        </li>
        <li>
          <span class="step">Paso 4:</span> Introduzca una descripción de la incidencia así como datos de contacto (obligatorios).
        </li>
        <li>
          <span class="step">Envío:</span> Confirme que los datos son correctos y pulse en el botón <ion-text color="primary">Enviar</ion-text>.
        </li>
      </ul>

      <h2>Ver sus incidencias</h2>

      <p>Puede ver el listado de sus incidencias pulsando en <ion-text color="primary">Tramitadas</ion-text> <ion-icon :icon="layersOutline" color="primary"/><br>
        Pulsando en cada elemento de dicho listado puede ver el detalle de dicha incidencia.</p>

      <p>Si desea ver sus incidencias geolocalizadas en el plano pulse en el boton <ion-text color="primary">Plano</ion-text> <ion-icon :icon="navigateCircleOutline" color="primary" /></p>

      <p class="version" v-if="version">Versión {{ version }}</p>
    </ion-content>
  </ion-page>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { IonPage, IonHeader, IonToolbar, IonContent, IonIcon, IonText, onIonViewWillEnter } from '@ionic/vue'
import { duplicateOutline, layersOutline, navigateCircleOutline, locateOutline } from 'ionicons/icons'
import { App } from '@capacitor/app'

import FormToolbar from '@/components/FormToolbar'
import { fileValidationService } from '@/services/file-validation-service'
import { deviceService } from '@/services/device-service'

const publicPath = process.env.BASE_URL

const maxFiles = fileValidationService.maxNumFiles
const version = ref<string>()

onIonViewWillEnter(async () => {
  if (deviceService.isWeb()) return
  const { version: v } =  await App.getInfo()
  version.value = v
})

</script>

<style lang="scss" scoped>

  h2 {
    font-size: 1.22rem;
    color: var(--ion-color-medium);
  }

  p {
    font-size: 0.95rem;
    text-align: justify;
  }

  .steps {
    margin-bottom: 25px;
    border-width: 1px;
    border-color: var(--ion-color-medium);
    border-style: solid;
    border-radius: 4px;
    padding: 10px 6px 6px 20px;
    list-style: inside square;

    li {
      font-size: 0.95rem;
      margin-bottom: 6px;
    }

    .step {
      font-weight: bold;
    }
  }

  ion-icon {
    position: relative;
    top: 2px;
  }

  .marker-map-redux {
    max-height: 20px;
    width: auto;
  }

  .version {
    color: var(--ion-color-medium);
    text-align: right;
    margin-top: 2rem;
    font-size: 0.8rem;
  }

</style>
